export enum ServerPushMessageType {
  TEXT = 'TEXT',
  ORDER = 'ORDER',
  TICKET = 'TICKET',
  TSLUPDATE = 'TSLUPDATE',
}
